<div class="main container albums">
	<div class="page-header">
		<h1>{{LOCALIZATION.albums}}</h1>
	</div>
	<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (navChange)="onTabChange($event)" class="nav nav-tabs nav-justified">
	  <li class="nav-item" [ngbNavItem]="1" *ngIf="userPermissions['ROLE_ALBUM_MANAGEMENT']">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.albumsPersonal }}
	    </a>	    
	    <ng-template ngbNavContent>
			<div *ngIf="!albums || albums.length < 1"><br><em>{{LOCALIZATION.albumsEmpty}}</em></div>
			<div class="col-xs-12 top-spacing bottom-spacing">
				<div class="text-right primary-controls">
					<button class="btn btn-accent btn-circle" (click)="addAlbum()" title="{{LOCALIZATION.albumAdd}}">
						<i class="fa fa-plus"></i>
					</button>
					<button class="btn btn-primary btn-circle" (click)="loadAlbums()" title="{{LOCALIZATION.refresh}}">
						<i class="fas fa-sync"></i>
					</button>
				</div>
			</div>
			<div *ngIf="albums && albums.length > 0" class="row text-center">
				<div *ngFor="let album of albums"
				 style="display: inline-block; float: none;"
				 class="album-container col-xs-12 col-sm-6 col-md-3">
					<div class="panel panel-default z-depth-1 album-container-panel">
						<div class="panel-heading panel-heading-min row-no-gutters" style="padding: 10px 10px;">
							<div class="col-xs-1"><i class="fa fa-share-alt accent-color" *ngIf="album.shared" title="{{LOCALIZATION.shared}}"></i></div>
							<div class="col-xs-10 truncate text-center">
								<span class="truncate pointMe" title="{{album.name}}" (click)="openAlbum(album)">{{album.name}}</span>
							</div>
							<div class="col-xs-1 col-xs-pull-1 dropdown menu-container" ngbDropdown>
							  <button type="button" 
							  	class="dropdown-toggle dropdown-toggle-fixed btn-menu btn-xs" 
							  	title="{{LOCALIZATION.actions}}" 
							  	[attr.aria-label]="LOCALIZATION.actions" 
							  	aria-haspopup="true"
							  	ngbDropdownToggle>
							      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
							  </button>
							  <ul class="dropdown-menu custom-drop dropdown-menu-right" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
								<li role="menuitem"><a title="{{LOCALIZATION.albumShare}}" (click)="shareAlbum(album)" class="pointMe accent-color" >{{LOCALIZATION.albumShare}}</a></li>
								<li role="menuitem"><a title="{{LOCALIZATION.edit}}" (click)="editAlbum(album)" class="pointMe accent-color" >{{LOCALIZATION.edit}}</a></li>
								<li *ngIf="album.pages" role="menuitem"><a title="{{LOCALIZATION.download}}" (click)="downloadAlbum(album)" class="pointMe accent-color" >{{LOCALIZATION.download}}</a></li>
								<li role="separator" class="divider"></li>
								<li *ngIf="album.pages" role="menuitem"><a title="{{LOCALIZATION.albumClean}}" (click)="cleanAlbum(album)" class="pointMe text-red" >{{LOCALIZATION.albumClean}}</a></li>
								<li role="menuitem"><a title="{{LOCALIZATION.deleteItem}}" (click)="deleteAlbum(album)" class="pointMe text-red" >{{LOCALIZATION.deleteItem}}</a></li>
							  </ul>
							</div>							
						</div>
						<div class="panel-body">
							<div class="text-center bottom-spacing">
								<img class="img-thumbnail pointMe" 
									(click)="openAlbum(album)" 
									[src]="album._thumbs" 
									onerror="this.src='/app/aw-ui-angular/assets/img/noimage.webp'" 
									alt="{{LOCALIZATION.thumbnail}}" title="Open album">
							</div>
							<div>
								<p class="truncate text-center" title="{{album.pages || 0}} item(s)">
									<em>{{
									  album.pages && album.pages === 1
									    ? (LOCALIZATION.albumDescription | formatString: album.pages)
									    : (album.pages && album.pages > 1 ? (LOCALIZATION.albumDescriptionPL | formatString: album.pages) : LOCALIZATION.albumEmpty)
									}}</em>									
								</p>
							</div>
							<div>
								<p class="truncate text-center" title="{{album.description}}">
									<em>{{album.description  | limitTo: 120}}</em>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pagination-container">
				<div class="text-center" *ngIf="albums && albums.length > 0">				  
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="pagination.page" 
					    [pageSize]="pagination.elementsPerPage"
					    [collectionSize]="pagination.totalElements" 
					    (pageChange)="pagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>
				</div>
			</div>		    
	    </ng-template>
	  </li>
	  <li class="nav-item" [ngbNavItem]="2" *ngIf="sharedalbums && (userPermissions['ROLE_ALBUM_MANAGEMENT'] || userPermissions['ROLE_ALBUM_VIEW'])">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.albumsShared }}
	    </a>	    
	    <ng-template ngbNavContent>
			<div *ngIf="!shared || shared.length < 1"><br><em>{{LOCALIZATION.albumsSharedEmpty}}</em></div>
			<div class="col-xs-12 bottom-spacing top-spacing" *ngIf="shared && shared.length > 0" >
				<div class="text-right primary-controls">
					<button class="btn btn-circle btn-primary" (click)="loadSharedAlbums()" title="{{LOCALIZATION.refresh}}">
						<i class="fas fa-sync"></i>
					</button>
				</div>
			</div>
			<div *ngIf="shared && shared.length > 0" class="row text-center">
				<div *ngFor="let album of shared"
				    style="display: inline-block; float: none;"				 
					class="album-container col-xs-12 col-sm-6 col-md-3">
					<div class="panel panel-default z-depth-1 album-container-panel">
						<div class="panel-heading panel-heading-min row-no-gutters" style="padding: 10px 10px;">
							<div class="col-xs-11 truncate text-center">
								<span class="truncate pointMe" title="{{album.name}}" (click)="openAlbum(album)">{{album.name}}</span>
							</div>
							<div class="col-xs-1 col-xs-pull-1 dropdown menu-container" ngbDropdown>
							  <button type="button" 
							  	class="dropdown-toggle dropdown-toggle-fixed btn-menu btn-xs" 
							  	title="{{LOCALIZATION.actions}}"
							  	[attr.aria-label]="LOCALIZATION.actions"
							  	aria-haspopup="true" 
							  	ngbDropdownToggle>
							      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
							  </button>
							  <ul class="dropdown-menu custom-drop dropdown-menu-right" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
							  	  <li role="menuitem"><a title="{{LOCALIZATION.albumRemoveShare}}" (click)="removeShare(album)" class="pointMe accent-color">{{LOCALIZATION.albumRemoveShare}}</a></li>
							  </ul>
							</div>							
						</div>
						<div class="panel-body">
							<div class="text-center bottom-spacing" >
								<img class="img-thumbnail pointMe" 
									(click)="openAlbum(album)" 
									[src]="album._thumbs" 
									onerror="this.src='/app/aw-ui-angular/assets/img/noimage.webp'" 
									alt="{{LOCALIZATION.thumbnail}}" 
									title="Open album">
							</div>
							<div>
								<p class="truncate text-center" title="{{album.pages || 0}} item(s)">
								<em>{{
								  album.pages && album.pages === 1
								    ? (LOCALIZATION.albumDescription | formatString: album.pages)
								    : (album.pages && album.pages > 1 ? (LOCALIZATION.albumDescriptionPL | formatString: album.pages) : LOCALIZATION.albumEmpty)
								}}</em>								
								</p>
							</div>
							<div>
								<p class="truncate text-center" title="{{album.description}}">
									<em>{{album.description | limitTo: 120}}</em>
								</p>
							</div>							
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pagination-container">
				<div class="text-center">	
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="sharedPagination.page" 
					    [pageSize]="sharedPagination.elementsPerPage"
					    [collectionSize]="sharedPagination.totalElements" 
					    (pageChange)="sharedPagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>							
				</div>
			</div>	    
	    </ng-template>	    
	  </li>
	</ul>
	<div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
